interface Props {
  strokeColor?: string;
}

export default function BorderedRectangle({ strokeColor = 'white' }: Props) {
  return (
    <>
      <svg width="16" height="8" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="1"
          y="1"
          width="14"
          height="6"
          stroke={strokeColor}
          fill="white"
          strokeWidth="2"
          rx="2"
          ry="2"
        />
      </svg>
    </>
  );
}
